import { postCreateEscalationThread } from 'api';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { IEscalationTasksErrorResponse, ICreateEscalationTasksSuccessResponse } from 'models';

interface Props {
  id: string;
  onSuccess?: (res: ICreateEscalationTasksSuccessResponse) => void;
  onError?: (err: IEscalationTasksErrorResponse) => void;
}

export const usePostCreateEscalationThread = ({
  id,
  onSuccess,
  onError,
}: Props): UseMutationResult<
  ICreateEscalationTasksSuccessResponse,
  IEscalationTasksErrorResponse,
  { message: string }
> => {
  const queryClient = useQueryClient();
  const mutation = useMutation((props: { message: string }) => postCreateEscalationThread(id, props), {
    onSuccess: (res) => {
      if (res.status === 'ok') {
        if (onSuccess) onSuccess(res);

        queryClient.invalidateQueries({
          queryKey: ['useFetchEscalationById', id],
        });

        return;
      }

      alert(res.message);
    },
    onError: (err: any) => {
      if (onError) {
        onError(err);
      }

      alert(err.response.message);
    },
  });

  return mutation;
};

export default usePostCreateEscalationThread;
